<template>
  <div class="country-switcher" @click="switchCountry(lang)">
    <div class="inner-container">
      <div class="toggle">
        <p>{{ labels.outsideCountry }}</p>
      </div>
      <div class="toggle">
        <p>{{ labels.insideCountry }}</p>
      </div>
    </div>
    <div class="inner-container" :class="{ 'outside': isOutside }" id='toggle-container'>
      <div class="toggle">
        <p>{{ labels.outsideCountry }}</p>
      </div>
      <div class="toggle">
        <p>{{ labels.insideCountry }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS } from '@/settings'

export default {
  computed: mapState({
    labels: state => LABELS[state.language],
    isOutside: state => state.form === 'light-external',
    lang: state => state.language
  }),
  methods: {
    switchCountry (e) {
      const toggleContainer = this.$el.getElementsByClassName('inner-container')[1]
      const isOutside = toggleContainer.className.indexOf('outside') === -1
      if (isOutside) {
        toggleContainer.className = 'inner-container outside'
        this.$store.dispatch('switchCountryForm', 'outside')
      } else {
        toggleContainer.className = 'inner-container'
        this.$store.dispatch('switchCountryForm', 'inside')
      }
    }
  }
}
</script>

<style scoped>
.oi-donate .country-switcher {
  width: 100%;
  height: 38px;
  margin-bottom: 10px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  user-select: none;
  cursor: pointer;
  background: #fff;
  color: rgba(0, 0, 0, 0.75);
  border: 1px solid #d1d1d1;
}

.oi-donate .country-switcher .inner-container {
  position: absolute;
  left: 0;
  top: 0;
  width: inherit;
  height: inherit;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 1px;
  font-weight: 700;
}

.oi-donate .country-switcher .inner-container:first-child {
  background: #fff;
  color: rgba(0, 0, 0, 0.75);
}

.oi-donate .country-switcher .inner-container:nth-child(2) {
  color: #fff;
  background: #ef4e23;
  clip-path: inset(0 50% 0 0);
  transition: .3s cubic-bezier(0,0,0,1);
  border-radius: 2px;
}

.oi-donate .country-switcher .toggle {
  width: 50%;
  position: absolute;
  height: inherit;
  display: flex;
  box-sizing: border-box;
}

.oi-donate .country-switcher .toggle p {
  margin: auto;
  font-size: 12px;
}

.oi-donate .country-switcher .toggle:nth-child(1) {
  right: 0;
}
.oi-donate .country-switcher .outside {
  clip-path: inset(0 0 0 50%)!important;
}
</style>
